<app-request-login-action-sheet
  [(visible)]="loginAdvertDisplayed"
></app-request-login-action-sheet>
<dx-button
  [text]="text"
  [type]="type"
  [disabled]="disabled"
  (onClick)="onButtonClick($event)">
</dx-button>
